import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { translate } from '@jsverse/transloco';
import { DropdownObject } from '@inmoment/the-kitchen';

import { AppSharedModule } from 'app/app-shared.module';
import { DashboardViewComponent } from 'app/modules/dashboard/pages/dashboard-view/dashboard-view.component';
import { WidgetGroup, Widget } from 'app/providers/bridge-api/dashboard.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-add-to-widget-group-dialog',
  templateUrl: './add-to-widget-group-dialog.component.html',
  styleUrls: ['./add-to-widget-group-dialog.component.scss'],
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AddToWidgetGroupDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Output() modalClosed: EventEmitter<any> = new EventEmitter<any>();
  @Input() dashboardViewComponent: DashboardViewComponent;
  @Input() widget: Widget;
  @Input() widgetGroupsInput: WidgetGroup[];
  @Input() disableType = false;

  addDFGForm: UntypedFormGroup;
  docFilterTypeData: DropdownObject[] = [
    { title: translate('widgets.add-to-widget-group-dialog.all-of-these'), id: 'and' },
    { title: translate('widgets.add-to-widget-group-dialog.any-of-these'), id: 'or' },
    { title: translate('widgets.add-to-widget-group-dialog.none-of-these'), id: 'not' },
  ];

  widgetGroups: DropdownObject[] = [];

  constructor(private formBuilder: UntypedFormBuilder) {
    this.addDFGForm = this.formBuilder.group({
      filterGroup: [],
      filterType: 'and',
    });
  }

  ngOnInit(): void {
    if (this.disableType) {
      this.addDFGForm.get('filterType').disable();
    }
    let filterGroups: WidgetGroup[];
    if (this.dashboardViewComponent) {
      filterGroups = this.dashboardViewComponent.widgetGroups();
    } else {
      filterGroups = this.widgetGroupsInput ?? [];
    }
    for (const group of filterGroups) {
      this.widgetGroups.push({ title: group.title, id: group.id });
    }
    if (filterGroups.length > 0) {
      const groupWithWidget = filterGroups.find((group) => group.widgets.includes(this.widget.id));
      const selectedGroup = groupWithWidget ? groupWithWidget.id : filterGroups[0].id;
      this.addDFGForm.setValue({
        filterGroup: selectedGroup,
        filterType: 'and',
      });
    }
  }

  get isValid() {
    return this.addDFGForm && this.addDFGForm.get('filterGroup').value;
  }

  onAddToDFG() {}

  onCancel() {
    this.modalClosed.emit(undefined);
  }

  onSave() {
    const result = {};
    result['filterGroup'] = this.widgetGroups.filter(
      (group) =>
        group.title === this.addDFGForm.get('filterGroup').value ||
        group.id === this.addDFGForm.get('filterGroup').value
    )[0];
    result['filterType'] = this.docFilterTypeData.filter(
      (type) =>
        type.title === this.addDFGForm.get('filterType').value ||
        type.id === this.addDFGForm.get('filterType').value
    )[0];
    this.modalClosed.emit(result);
  }
}
